import { render } from "./index.vue?vue&type=template&id=b6262702&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b6262702&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6262702"

export default script